// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../fetch.pb.js";
export const TaskService = {
    CreateTasks(fn, req) {
        return fn(`/task-center/v1/tasks`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListTasks(fn, req) {
        return fn(`/task-center/v1/tasks/list`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    TasksStats(fn, req) {
        return fn(`/task-center/v1/tasks/stats`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetTaskStatsByLocationAndType(fn, req) {
        return fn(`/task-center/v1/tasks/stats/v2`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateTask(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/task-center/v1/tasks/${req["id"]}`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteTask(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/task-center/v1/tasks/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    ListOrgTasks(fn, req) {
        return fn(`/task-center/v1/tasks/org/list`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
